import requests from "./httpService";

const CategoryServices = {

    getCategory: async () =>{
        return requests.get(`/category`);
    },
    getCategoryActive: async () =>{
        return requests.get(`/category/active`);
    },
    getSubCategoryByCategory: async (categoryId) =>{
        return requests.get(`/subcategory/${categoryId}`);
    },
    updateCategory : async (id,body) =>{
        return requests.patch(`/category/${id}`,body);
    },

    createCategory : async (body) =>{
    
        return requests.post(`/category`,body);
    },
    
    deleteCategory : async (id) =>{
        return requests.delete(`/category/${id}`);
    }
  


}
export default CategoryServices;